// Search data structure for website-wide search functionality
export interface SearchItem {
  id: string;
  section: string;
  title: string;
  content: string;
  keywords: string[];
  sectionId: string;
}

export const searchData: SearchItem[] = [
  // Hero section
  {
    id: "hero-main",
    section: "Kezdőlap",
    title: "YOGIVITY bemutatása",
    content: "Fedezd fel a TE utadat a hosszú élethez és a vitalitáshoz. YOGIVITY program hosszú minőségi élet és vitalitás.",
    keywords: ["yogivity", "hosszú élet", "vitalitás", "longevity", "jógatanár", "étkezési tanácsadó"],
    sectionId: "home"
  },
  {
    id: "hero-services",
    section: "Szolgáltatásaim",
    title: "Szolgáltatások áttekintése",
    content: "Hat Hetes Életmódprogram, Étkezési Tanácsadás, 10+ Online Óra",
    keywords: ["életmódprogram", "étkezési tanácsadás", "online óra", "jógaóra", "tanácsadás"],
    sectionId: "home"
  },

  // Services section
  {
    id: "services-yogivity",
    section: "Szolgáltatásaim",
    title: "YOGIVITY Program",
    content: "Komplex program hosszú élettartam és jóllét célzó. Ötvözi ősi jóga bölcsességét modern egészségtudománnyal.",
    keywords: ["yogivity program", "6 hét", "életmód", "jóga", "stresszkezelés", "étrend", "konzultáció"],
    sectionId: "services"
  },
  {
    id: "services-nutrition",
    section: "Szolgáltatásaim",
    title: "Étkezési Tanácsadás",
    content: "Személyreszabott kiegyensúlyozott élvezetes étkezés. Testsúly csökkentés növelés vagy szinten tartás.",
    keywords: ["étkezés", "tanácsadás", "étrend", "testsúly", "egészséges étkezés", "ételcsere"],
    sectionId: "services"
  },
  {
    id: "services-online",
    section: "Szolgáltatásaim",
    title: "Jógázz Online",
    content: "Korlátlan videó hozzáférés. Jógaórák meditációk légzőgyakorlatok könnyű súlyzós gyakorlatok.",
    keywords: ["online jóga", "videók", "meditáció", "légzőgyakorlat", "súlyzós gyakorlat", "jógaóra"],
    sectionId: "services"
  },

  // About section
  {
    id: "about-dorottya",
    section: "Rólam",
    title: "Berekvölgyi Dorottya",
    content: "Berekvölgyi Dorottya vagyok, de nyugodtan hívhatsz Dorkának is. Jógatanár és étkezési tanácsadó.",
    keywords: ["dorottya", "dorka", "berekvölgyi", "jógatanár", "étkezési tanácsadó", "közgazdász"],
    sectionId: "about"
  },
  {
    id: "about-certificates",
    section: "Rólam",
    title: "Tanúsítványok és szakterületek",
    content: "200 órás jógatanári képzés, Étkezési Tanácsadó, Közgazdász. Biológiai fiatalság, Stresszkezelés, Erősítés, Nyújtás, Kiegyensúlyozott étkezés.",
    keywords: ["tanúsítvány", "jógatanár képzés", "közgazdász", "biológiai fiatalság", "stresszkezelés", "erősítés", "nyújtás"],
    sectionId: "about"
  },

  // Testimonials section
  {
    id: "testimonials-csilla",
    section: "Vélemények",
    title: "Csilla véleménye",
    content: "Egyéni 6 alkalmas online YOGIVITY program. Személyre szabott figyelem, napi rutin, mozgás, falási rohamok.",
    keywords: ["vélemény", "csilla", "online program", "személyre szabott", "mozgás", "étrend", "belső egyensúly"],
    sectionId: "testimonials"
  },

  // Newsletter section
  {
    id: "newsletter",
    section: "Hírlevél",
    title: "Hírlevél feliratkozás",
    content: "Iratkozz fel a hírlevelemre. Jóga, hosszú élet, táplálkozás, új tartalmak és programok.",
    keywords: ["hírlevél", "feliratkozás", "jóga", "táplálkozás", "programok", "közösség"],
    sectionId: "newsletter"
  },

  // Contact section
  {
    id: "contact-form",
    section: "Kapcsolat",
    title: "Kapcsolatfelvétel",
    content: "Tedd meg az első lépéseket. Írd meg kérdéseidet jóga és egészséges életmód kapcsolatban.",
    keywords: ["kapcsolat", "űrlap", "kérdés", "jóga", "egészséges életmód", "konzultáció"],
    sectionId: "contact"
  }
];

// Search function
export function searchContent(query: string): SearchItem[] {
  if (!query.trim()) return [];

  const searchTerm = query.toLowerCase().trim();
  
  return searchData.filter(item => {
    // Search in title
    if (item.title.toLowerCase().includes(searchTerm)) return true;
    
    // Search in content
    if (item.content.toLowerCase().includes(searchTerm)) return true;
    
    // Search in keywords
    if (item.keywords.some(keyword => keyword.toLowerCase().includes(searchTerm))) return true;
    
    // Search in section name
    if (item.section.toLowerCase().includes(searchTerm)) return true;
    
    return false;
  });
}

// Scroll to section function
export function scrollToSection(sectionId: string) {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }
}
